import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=5a132177&scoped=true&"
import script from "./Memo.vue?vue&type=script&lang=js&"
export * from "./Memo.vue?vue&type=script&lang=js&"
import style0 from "./Memo.vue?vue&type=style&index=0&id=5a132177&scoped=true&lang=less&"
import style1 from "./Memo.vue?vue&type=style&index=1&id=5a132177&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a132177",
  null
  
)

export default component.exports